import { useEffect, useState } from 'react';
import { fetchItensPedido } from '../../services/itemPedidoService';
import { IitemPedido } from '../../interfaces/itemPedido';

const useFetchItensPedido = () => {
  const [itens, setItens] = useState<IitemPedido[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const getItens = async () => {
      try {
        const data = await fetchItensPedido();
        setItens(data);
      } catch (err) {
        setError('Falha ao buscar itens de pedido');
      } finally {
        setLoading(false);
      }
    };

    getItens();
  }, []);

  return { itens, loading, error };
};

export default useFetchItensPedido;
